import { useEffect, useState } from "react";
import Link from "next/link";
import Head from "next/head";
import { CONSTANTS } from "../../../util/utils";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";
export default function Header({ data }) {
  const HeaderLogo = () => {
    return (
      <>
        <Head>
          <link rel="preload" as="image" href={data.logo.img.src} />
        </Head>
        <Link
          href={data.logo.href}
          prefetch={false}
          className="company-logo lg:mr-3"
          id={data.logo.id}
          aria-label={data.logo.img.alt}
        >
          <img
            width={data.logo.img.dimensions[0]}
            height={data.logo.img.dimensions[1]}
            src={data.logo.img.src}
            alt={data.logo.img.alt}
          />
          <style jsx>{`
            @media (max-width: ${viewport.tablet.sm}) {
              .company-logo img {
                width: 130px;
              }
            }
            @media (max-width: ${viewport.mobile.sm}) {
              .company-logo {
                margin-right: 4px;
              }
            }
          `}</style>
        </Link>
      </>
    );
  };
  const StickyHeader = () => {
    const header = document.querySelector("header");
    function makeItFixed() {
      if (window.scrollY > 20) {
        header.classList.add("is-fixed");
      } else {
        header.classList.remove("is-fixed");
      }
    }
    window.addEventListener("scroll", () => {
      makeItFixed();
    });

    window.addEventListener("load", () => {
      makeItFixed();
    });
  };

  const ContactAndLoginSection = () => {
    return (
      <div className="minimal-nav-desktop">
        {data.hasOwnProperty("contact") && (
          <a
            className="contact-number hover-link-blue md:d-none"
            href={data.contact.href}
          >
            {data.contact.text}
          </a>
        )}
        {data.hasOwnProperty("login") && (
          <a
            href={
              process.env.APP_MODE === "live"
                ? CONSTANTS.live.loginUrl
                : CONSTANTS.staging.loginUrl
            }
            className="ml-4 hover-link-blue"
            id={data.login.id}
          >
            <span>{data.login.text}</span>
          </a>
        )}
        <style jsx>{`
          div {
            margin-left: auto;
          }
        `}</style>
      </div>
    );
  };
  useEffect(() => {
    StickyHeader();
  });

  return (
    <header className={`is-variant is-minimal`}>
      <div className="main-header container">
        <HeaderLogo />
        {(data.hasOwnProperty("contact") || data.hasOwnProperty("login")) && (
          <ContactAndLoginSection />
        )}
      </div>
      <style jsx>{`
        .is-variant {
          position: fixed;
          left: 0;
          right: 0;
          top: 0;
          z-index: 10;
          transition: 0.5s box-shadow linear;
        }
        .is-variant.is-fixed {
          position: fixed;
          top: 0;
          background-color: ${colors.primitive.white.default};
          box-shadow: 0 2px 4px 0 rgba(22, 45, 61, 0.2);
        }
        .is-minimal .main-header .minimal-nav-desktop,
        .is-minimal .main-header .minimal-nav-mobile {
          display: none;
        }
        .is-minimal .main-header > :first-child {
          margin-right: auto;
        }
        .main-header {
          display: flex;
          align-items: center;
          padding: 28px 0;
        }
        .main-header > nav a {
          display: inline-block;
          line-height: ${lineHeight[6]};
          vertical-align: middle;
        }
        .buttons-wrap {
          margin-left: auto;
        }
        .page-signup .minimal-nav-desktop .btn-outline {
          min-width: 120px;
          margin: 0 0 0 32px;
          padding: 4px 44px 4px 42px;
          border-radius: 6px;
        }
        .page-signup .minimal-nav-desktop .btn-outline span {
          font-size: ${font.size.sm[3]};
          line-height: ${lineHeight[6]};
        }
        @media (min-width: ${viewport.tablet.md}) {
          .is-minimal.main-header {
            padding: 28px 0;
          }
          .is-minimal .main-header .minimal-nav-desktop {
            display: block;
          }
          .menu-open,
          .mobile-menu,
          .mobile-menu-wrap {
            display: none;
          }
        }
        @media (max-width: ${viewport.tablet.md}) {
          .is-minimal.main-header.minimal-nav-mobile {
            display: block;
          }
          .main-header {
            padding: 18px 0;
            height: 56px;
          }
          .main-header .buttons-wrap,
          .main-header > nav {
            display: none;
          }
        }
      `}</style>
    </header>
  );
}
